import styled from 'styled-components';

export const ProgressBarContainer = styled.div`
  display: flex;
  user-select: none;
  justify-items: center;
  & > .label {
    font-size: 0.8rem;
    min-width: 6rem;
    font-weight: bold;
    border-left: solid 2px #444;
    padding-left: 0.5rem;
  }
  & > .progress {
    flex-grow: 1;
  }
`;
